import React, { useEffect, useState, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Box, Skeleton, Typography } from '@mui/material';
import { BarChart } from '../../../shared';
import { WORST_REACH_CHART_OPTIONS } from './constants';

const WorstEngagementChart = ({ title, type }) => {
    const { company } = useSelector((state) => state.company) || {};
    const { dtcData } = useSelector((state) => state.paidSearch) || {};
    const {
        isPaidSearchLoading,
        worstEngagementChart,
        worstHCPSearchChart,
        worstSearchClicksChart
    } = dtcData || {};

    const chartDataMap = {
        worst_engagements: worstEngagementChart,
        worst_hcp_search: worstHCPSearchChart,
        worst_search_click: worstSearchClicksChart
    };

    const selectedData = chartDataMap[type] || worstEngagementChart;
    const categories = selectedData?.categories || [];
    const data = selectedData?.data || [];

    const [key, setKey] = useState(0);
    useEffect(() => {
        setKey((prevKey) => prevKey + 1);
    }, [company]);

    const chartSeries = useMemo(() => {
        const seriesData = Array.isArray(data)
            ? data.map((item) => (item?.total || item?.totalPercentage) ?? 0)
            : [];
        return [{ name: type, data: seriesData }];
    }, [data]);

    const barChartOptions = useMemo(() => ({
        ...WORST_REACH_CHART_OPTIONS,
        xaxis: {
            ...WORST_REACH_CHART_OPTIONS.xaxis,
            categories
        },
        plotOptions: {
            ...WORST_REACH_CHART_OPTIONS.plotOptions,
            bar: {
                ...WORST_REACH_CHART_OPTIONS.plotOptions.bar,
                barHeight: categories.length === 1 ? 45 : '100%'
            }
        },
        tooltip: {
            enabled: true,
            marker: { show: false },
            custom: function ({
                series, seriesIndex, dataPointIndex, w 
            }) {
                const item = data?.[dataPointIndex];
                const label = w.globals.labels[dataPointIndex];
                const engagement = (item?.total || item?.totalPercentage) ?? 'N/A';
                return `
            <div style="padding:8px; background:white; border-radius:4px; box-shadow:0px 0px 4px rgba(0,0,0,0.2);">
              <p style="margin:0; font-size:14px; font-weight:bold;">${label}</p>
              <p style="margin:0;">Engagement: <span style="font-weight:bold;">${engagement}</span></p>
            </div>
          `;
            }
        }
    }), [categories, data]);

    const isLoading = isPaidSearchLoading;

    return (
        <Box className="container-p-24-br-16 bg-gray-50 height-100">
            <Typography className="text-md-medium gray-900" mb={2}>
                {title}
            </Typography>

            <Box className="wh-100" id="worst-engagement-chart">
                {isLoading ? (
                    <Skeleton height={400} variant="rectangular" width="100%" />
                ) : data.length === 0 ? (
                    <Box
                        alignItems="center"
                        display="flex"
                        height={300}
                        justifyContent="center"
                    >
                        <Typography color="textSecondary">No data available</Typography>
                    </Box>
                ) : (
                    <BarChart
                        chartOptions={barChartOptions}
                        chartSeries={chartSeries}
                        height="300px"
                        key={key}
                    />
                )}
            </Box>
        </Box>
    );
};

export default WorstEngagementChart;
